<button (click)="switch($event)">
    <mat-icon>{{ icon }}</mat-icon>
</button>
